<template>
  <div class="vc-w-100 vc-home-forward">
    <v-row class="vc-w-100 ma-0 content text-center vc-flex-center">
      <v-col cols="12" class="pa-0">
        <img height="48px" src="@/assets/img/vatm.png" alt="" />
      </v-col>

      <v-col v-if="!lastPerson" cols="12" class="pa-0 pa-2 primaryLight mt-3 ">
        <v-alert
          dense
          border="left"
          color="primary"
          type="info"
          class="mb-0 alert-text"
        >
          Você <strong>precisa</strong> chamar uma ficha para realizar o
          encaminhamento.
        </v-alert>
      </v-col>

      <v-col cols="12" class="pa-0 mt-7 mb-5">
        <v-alert v-if="lastPerson">
          Encaminhando a ficha:
          <strong>
            <h3>{{ `${lastPerson.type_key}${lastPerson.key}` }}</h3>
          </strong>
        </v-alert>
        <v-alert
          v-if="lastPerson"
          dense
          border="left"
          color="success"
          type="info"
          class="mb-5"
        >
          {{
            namePerson
              ? 'Preencha o local para encaminhamento.'
              : 'Preencha o nome do cliente e o local para encaminhamento.'
          }}
        </v-alert>
        <v-autocomplete
          class="vc-w-100"
          v-model="selectedPlaceId"
          solo
          :background-color="!lastPerson ? 'vcGrey' : 'primaryLight'"
          label="Local"
          :items="places"
          item-text="name"
          item-value="_id"
          hide-details
          :disabled="!lastPerson"
        >
          <template v-slot:selection="data">
            {{ `${data.item.name}` }}
          </template>
          <template v-slot:item="data">
            <template>
              <v-list-item-content>
                <v-list-item-title
                  v-html="`${data.item.name}`"
                ></v-list-item-title>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" class="pa-0 mb-5">
        <v-text-field
          v-model="namePerson"
          :disabled="!lastPerson"
          class="vc-w-100"
          :background-color="!lastPerson ? 'vcGrey' : 'primaryLight'"
          label="Digite o nome da pessoa"
          solo
          hide-details
        ></v-text-field>
      </v-col>

      <v-col cols="12" class="pa-0 mb-5">
        <v-textarea
          v-model="observationPerson"
          :disabled="!lastPerson"
          class="vc-w-100"
          :background-color="!lastPerson ? 'vcGrey' : 'primaryLight'"
          label="Observações"
          solo
          hide-details
          rows="4"
          auto-grow
        ></v-textarea>
      </v-col>
      <v-col
        v-if="showAlertPerson || showAlert"
        cols="12"
        class="pa-0 pa-2 primaryLight vc-br-10 mb-5"
      >
        <v-alert
          v-if="showAlertPerson"
          dense
          border="left"
          color="primary"
          type="info"
          class="mb-0 alert-text"
        >
          Você <strong>precisa</strong> chamar uma ficha antes de realizar esta
          ação.
        </v-alert>
        <v-alert
          v-if="showAlert"
          dense
          border="left"
          color="primary"
          type="info"
          class="mb-0 mt-2 alert-text"
        >
          Preencha <strong>todos</strong> os campos acima para efetuar a ação.
        </v-alert>
      </v-col>
      <v-col cols="12" class="pa-0">
        <v-btn
          max-width="200"
          color="primary"
          class=" white--text vc-w-100 vc-br-10"
          :disabled="!lastPerson"
          @click="forwardClient"
        >
          <div class="vc-text-button">encaminhar</div>
          <v-icon size="20" class="ml-3" right color="white">
            mdi-send
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { eventBus } from '@/main';
import ls from "local-storage";

export default {
  name: 'vc-forward',
  data() {
    return {
      selectedPlace: '',
      namePerson: '',
      observationPerson: '',
      selectedPlaceId: '',
      showAlert: false,
      showAlertPerson: false,
      lastCallComum: null,
    };
  },
  mounted() {
    eventBus.$on('sendComum', (data) => {
      this.lastCallComum = data;
    });
  },
  watch: {
    lastPerson() {
      if (this.lastPerson && this.lastPerson.name) {
        this.namePerson = this.lastPerson.name;
      }
      if (this.lastPerson && this.lastPerson.observation) {
        this.observationPerson = this.lastPerson.observation;
      }
    },
  },
  props: {
    places: { type: Array, default: () => {} },
    lastPerson: { type: Object, default: () => {} },
    currentPlace: { type: Object, default: () => {} },
  },
  methods: {
    forwardClient() {
      this.$store.commit('SET_ALL_QUEUES');
      this.showAlert = false;
      !this.lastPerson
        ? (this.showAlertPerson = true)
        : (this.showAlertPerson = false);
      if (this.selectedPlaceId && this.namePerson) {
        const selectedPlaceName = this.getSelectedPlaceName();
        console.log('lastPerson', this.lastPerson._id);
        var changeIdClean = this.lastPerson._id;
        let body = {
          name: this.namePerson,
          people_id: this.lastPerson._id,
          place_id: this.selectedPlaceId,
          observation: this.observationPerson,
        };
        this.$notify({
          group: 'foo',
          title: 'Sucesso',
          text: `Cliente ${body.name} encaminhado para ${selectedPlaceName}`,
          type: 'success',
        });
        document.title = `V-ATM | Último: ${this.namePerson}`;
        this.$store.dispatch('forwardClient', body).then(() => {
          if (this.lastCallComum) {
            eventBus.$emit('cleanLastCallComum', `${changeIdClean}`);
            this.lastCallComum = null;
            this.namePerson = '';
            this.selectedPlaceId = '';
            this.observationPerson = '';
            
          } else {
            eventBus.$emit('cleanLastCallPreferential', `${changeIdClean}`);
            this.namePerson = '';
            this.selectedPlaceId = '';
            this.observationPerson = '';
          }
          if (ls.get('currentPlace')) {
            this.$store.dispatch('setTokensByPlace', this.currentPlace);
          }
        });
      } else {
        this.showAlert = true;
      }
    },
    getSelectedPlaceName() {
      const place = this.places.find(
        (place) => place._id === this.selectedPlaceId
      );
      return place ? place.name : '';
    },
  },
};
</script>
